import actionCreatorFactory from 'typescript-fsa';

const create = actionCreatorFactory('FEATURE_FLAGS');

export const setFeatureFlag = create<{
  name: string;
  value: boolean;
}>('SET_FLAG');
